import React from "react";
export interface ProductHighLevelProps {
  productDepartment: string;
  productName: string;
  productScent?: string;
  productLevelDescription: string;
  productHighlight: string;
  productId: number;
  hideReviews?: boolean;
}

export const ProductHighlight = ({
  productName,
  productScent,
  productLevelDescription,
  productDepartment,
  productHighlight,
  productId,
  hideReviews = false,
}: ProductHighLevelProps) => {
  return (
    <div className="flex flex-col pb-2 text-left lg:pb-4">
      {hideReviews === false && (
        <div
          data-bv-show="rating_summary"
          data-bv-product-id={productId}
          style={{ minHeight: "18px" }}
        ></div>
      )}
      <h1 className="title">
        {productName}
        {productScent && <span className="sr-only">{productScent}</span>}
      </h1>
      {productLevelDescription && (
        <p className="body pb-2">{productLevelDescription}</p>
      )}
      {productHighlight && <p className="body pt-4">{productHighlight}</p>}
    </div>
  );
};
